export const questionsettings = (offset) => {
  let data = {
    dots: false,
    infinite: false,
    speed: 250,
    arrows: true,
    vertical: true,
    slidesToShow: 10,
    slidesToScroll: 10,
    initialSlide: offset,
  };
  return data;
};



// WEBPACK FOOTER //
// ./src/common/cbtleftnavigationsettings.js